export const resolveSafeNextPath = (value?: string | null): string | null => {
  if (!value) return null
  const trimmed = value.trim()
  if (!trimmed.startsWith('/') || trimmed.startsWith('//')) return null
  if (trimmed.startsWith('/continue')) return null
  return trimmed
}

export const buildContinuePath = (nextValue?: string | null): string => {
  const safeNext = resolveSafeNextPath(nextValue)
  if (!safeNext) return '/continue'
  const params = new URLSearchParams()
  params.set('next', safeNext)
  return `/continue?${params.toString()}`
}
